import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FileTransfer } from '@ionic-native/file-transfer';
import { LoopBackConfig } from '../../sdk/lb.config';
import { Storage } from "@ionic/storage";
import { NestAuthProvider } from '../nest-auth';
import { StoragePathProvider } from '../../../providers/storage-path/storage-path';
import { File } from '@ionic-native/file';
import { NestApiProvider } from '../nest-api';
import { Paginate } from '../../../model/paginate';
import { ResponseBatchDetailDto } from '../gd-only/dto/make-idcard.dto';
import { Observable } from 'rxjs';
import { RequestGetEmpDto } from '../gd-only/dto/employees.dto';

@Injectable()
export class MakeIdCardApiProvider {

  module: string = 'makeIdCard';

  accessToken: any;
  headerOptions: any;
  headerOptionsJson: any;
  attendancePath: any = LoopBackConfig.getPath();
  timeout: number = 30000;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    public platform: Platform,
    public nestAuth: NestAuthProvider,
    public transfer: FileTransfer,
    public file: File,
    public storagePathProvider: StoragePathProvider,
    public nestApi: NestApiProvider
  ) {

  }

  checkPhoto(formData: any) {
    const method: string = "POST";
    const model: string = "makeIdCard";
    const func: string = "checkPhoto";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  batchCards(formData: { companyCode: string, page: number, limit: number }) {
    const method: string = "POST";
    const model: string = "makeIdCard";
    const func: string = "batchCards";
    const params: any = { companyCode: formData.companyCode };
    const urlParams: any = { page: formData.page, limit: formData.limit };
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  batchDetail(formData: { companyCode: string, id: number }, queryParams: { limit: number, page: number }) : Observable<ResponseBatchDetailDto> {
    const method: string = "POST";
    const model: string = "makeIdCard";
    const func: string = "batchDetails";
    const params: any = formData;
    const urlParams: any = queryParams;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<ResponseBatchDetailDto>(method, url, params, urlParams, body, contentType);
  }

  previewCard(formData: any) {
    const method: string = "POST";
    const model: string = "makeIdCard";
    const func: string = "previewCard";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  saveIdCard(formData: any) {
    const method: string = "POST";
    const model: string = "makeIdCard";
    const func: string = "saveIdCard";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }

  getEmployeeLists(payload: RequestGetEmpDto, queryParams: { page: number, limit: number }) {
    const method: string = "POST";
    const model: string = "makeIdCard";
    const func: string = "getEmployeeLists";
    if (payload.active === '' || payload.active === null) {
      payload.active = '1'
    }
    const params: RequestGetEmpDto = payload;
    const urlParams: any = queryParams;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/make-id-card/make-id-card-api.ts